module.exports = __webpack_public_path__ + "assets/687a7616f7adb5ab2ec92df06dd624fd.png";